"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseDataProvider = void 0;
const utils_1 = require("../../../utils");
const lodash_1 = __importDefault(require("lodash"));
const firestore_1 = require("rxfire/firestore");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
class BaseDataProvider {
    constructor(refs, connectivityService) {
        this.refs = refs;
        this.connectivityService = connectivityService;
    }
    /**
     * creates a document data stream using the connectivity service so the stream can be re-initiated whenever we want to reconnect
     * @param forceReconnectable if the stream should force refresh when the connection is lost. Streams will always auto recover eventually but making it reconnectable sometimes improves the speed. Only use when it's really needed.
     *
     */
    docDataStream(ref, forceReconnectable) {
        if (forceReconnectable) {
            return this.connectivityService.withReconnectionStream(() => this.docData(ref));
        }
        return this.docData(ref);
    }
    /**
     * creates a collection data stream using the connectivity service so the stream can be re-initiated whenever we want to reconnect
     *  @param forceReconnectable if the stream should force refresh when the connection is lost. Streams will always auto recover eventually but making it reconnectable sometimes improves the speed. Only use when it's really needed.
     */
    collectionDataStream(ref, forceReconnectable) {
        if (forceReconnectable) {
            return this.connectivityService.withReconnectionStream(() => this.collectionData(ref));
        }
        return this.collectionData(ref);
    }
    async docPromise(ref) {
        const doc = await ref.get();
        if (!doc)
            return undefined;
        const res = await this.decodeDoc(doc);
        return res;
    }
    async firstAsDocPromise(ref) {
        const snap = await ref.get();
        const doc = snap.docs[0];
        if (!doc)
            return undefined;
        const res = await this.decodeDoc(doc);
        return res;
    }
    async collectionPromise(ref) {
        const docs = await ref.get();
        const data = lodash_1.default.map(docs.docs, (doc) => {
            return this.decodeDoc(doc);
        });
        return lodash_1.default.compact(data);
    }
    /**
     * Get a paginatable collection
     */
    collectionSubjectWithCursorNext(ref, limit) {
        const list = new rxjs_1.BehaviorSubject([]);
        const hasMore = new rxjs_1.BehaviorSubject(false);
        let last;
        const add = (docs) => {
            // store a ref to the last document
            last = lodash_1.default.last(docs.docs);
            hasMore.next(docs.size >= limit);
            const data = lodash_1.default.map(docs.docs, (doc) => this.decodeDoc(doc));
            list.next(list.value.concat(lodash_1.default.compact(data)));
            return hasMore.value;
        };
        const next = async () => {
            if (!last)
                return false;
            return (ref
                // tell firebase to start from the last document
                .startAfter(last)
                .limit(limit)
                .get()
                .then(add));
        };
        void ref.limit(limit).get().then(add);
        return {
            list,
            next,
            hasMore,
        };
    }
    decodeDoc(doc) {
        // a real json decoder would be nice in the future
        return doc.exists ? doc.data() : undefined;
    }
    /**
     * DON'T use the rxfire docData function, this returns an empty object instead of undefined\
     */
    docData(ref) {
        return (0, firestore_1.doc)(ref).pipe((0, operators_1.map)((d) => d.data()));
    }
    /**
     * DON'T use the rxfire collectionData function, this returns an empty object instead of undefined
     */
    collectionData(ref) {
        return (0, firestore_1.collection)(ref).pipe((0, operators_1.map)((docs) => (0, utils_1.compactMap)(docs, (d) => {
            return d.data();
        })));
    }
    async insertWithId(collection, doc) {
        const ref = collection.doc();
        await ref.set({
            _id: ref.id,
            ...doc,
        });
        return ref.id;
    }
}
exports.BaseDataProvider = BaseDataProvider;
//# sourceMappingURL=BaseDataProvider.js.map